import React from "react";

import svg from "../../assets/images/icons/Form Controls/Text Area.svg";

export const MultiLineTextIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Textarea"}
    />
);
